import { render } from "./Tax_Mapping.vue?vue&type=template&id=b66ca79c"
import script from "./Tax_Mapping.vue?vue&type=script&lang=js"
export * from "./Tax_Mapping.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__